import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import Button from 'shopper/components/Button';
import Icon from 'shopper/components/Icon';
import Tooltip from 'shopper/components/Tooltip';

const ToolButton = forwardRef(
  (
    { active = false, 'aria-label': ariaLabel, iconName, tip, onClick },
    ref
  ) => (
    <Tooltip.Root>
      <Tooltip.Trigger>
        <Button
          ref={ref}
          aria-label={ariaLabel}
          icon={<Icon name={iconName} />}
          size="size3"
          type={active ? 'neutral-stroke' : 'neutral-ghost'}
          onClick={onClick}
        />
      </Tooltip.Trigger>
      <Tooltip.Box className="w-max">{tip}</Tooltip.Box>
    </Tooltip.Root>
  )
);

ToolButton.displayName = 'ToolButton';

ToolButton.propTypes = {
  active: PropTypes.bool,
  'aria-label': PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
  tip: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ToolButton;
